import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import Layout from '../components/Layout/Layout';
import Home from './Home';

const HomeWrapper = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background-light dark:bg-background-dark">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-light dark:border-primary-dark mx-auto mb-4"></div>
          <p className="text-muted-light dark:text-muted-dark">Carregando...</p>
        </div>
      </div>
    );
  }

  // Se o usuário está logado, mostrar com Layout (navbar)
  if (user) {
    return (
      <Layout>
        <Home />
      </Layout>
    );
  }

  // Se não está logado, mostrar sem Layout
  return <Home />;
};

export default HomeWrapper;





